import React, { useEffect, useState } from 'react';
import { Routes, Route } from "react-router-dom";
import DrawerAppBar from './Components/NavBar';
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Footer from './Components/Footer';
import CommunityFlagging from './pages/CommunityFlagging';
import DefenceGame from './pages/DefenceGame';
import Quiz from './pages/Quiz';
import DeepfakeAnalysis from './pages/DeepfakeAnalysis';
import Dashboard from './pages/Dashboard';
import PersonalDashboard from './pages/PersonalDashboard';
import Education from './pages/Education';
import QuickCheck from './pages/quick_check';
import axios from 'axios';
import CoursePage from './Components/CoursePage/CoursePage';
import LoginScreen from './LoginScreen';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Box from '@mui/material/Box';


function App() {
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const isAuthenticated = localStorage.getItem("auth") === "true";
    if (isAuthenticated) setAuthenticated(true);

    if (!localStorage.getItem("token")) {
      axios
        .get("https://dun.vydeo.xyz/iter3/get_token")
        .then((res) => {
          localStorage.setItem("token", res.data.token);
          window.postMessage({ type: 'TOKEN', token: res.data.token }, '*');
        })
        .catch((error) => console.error("Error fetching token:", error));
    } else {
      window.postMessage({ type: 'TOKEN', token: localStorage.getItem("token") }, '*');
    }
  }, []);

  const handleLoginSuccess = () => {
    setAuthenticated(true);
    localStorage.setItem("auth", "true");
  };

  return (
    <>
      <Routes>
        {/* Public Route */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        {/* Authenticated Routes */}
        <Route
          path="*"
          element={
            authenticated ? (
              <>
                <Box sx={{ position: 'relative', zIndex: 1000 }}>
                  <DrawerAppBar />
                </Box>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/home" element={<Home />} />
                  <Route path="/personal-dashboard" element={<PersonalDashboard />} />
                  <Route path="/education" element={<Education />} />
                  <Route path="/community-flagging" element={<CommunityFlagging />} />
                  <Route path="/defence-game" element={<DefenceGame />} />
                  <Route path="/quick-check" element={<QuickCheck />} />
                  <Route path="/quiz" element={<Quiz />} />
                  <Route path="/course/:courseId" element={<CoursePage />} />
                </Routes>
              </>
            ) : (
              <LoginScreen onSuccess={handleLoginSuccess} />
            )
          }
        />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
